import { render, staticRenderFns } from "./CreateWhoModal.vue?vue&type=template&id=b59df050&"
import script from "./CreateWhoModal.vue?vue&type=script&lang=js&"
export * from "./CreateWhoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b59df050')) {
      api.createRecord('b59df050', component.options)
    } else {
      api.reload('b59df050', component.options)
    }
    module.hot.accept("./CreateWhoModal.vue?vue&type=template&id=b59df050&", function () {
      api.rerender('b59df050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/CreateWhoModal.vue"
export default component.exports